import { useQuery } from '@tanstack/react-query';
import { portalGet } from '@/lib/portal/customerClient';
import { usePortalAuthStore } from '@/stores/portalAuth.store';

export interface PortalDocument {
  id: string;
  title: string;
  kind: 'estimate' | 'invoice' | 'membership' | 'report';
  date: string | null;
  url: string;
}

/** The signed-in contact's documents (estimate/invoice/membership PDFs + reports). */
export function usePortalDocuments() {
  const token = usePortalAuthStore((s) => s.token);
  return useQuery({
    queryKey: ['portal', 'documents', token],
    queryFn: () => portalGet<PortalDocument[]>('/api/portal/documents'),
    enabled: Boolean(token),
    retry: false,
  });
}
